import React, { useState } from 'react';
import { MenuItem, Avatar, Divider, Typography, Select, Box, Stack } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import * as CONSTANTS from "../../constants";

const UserMenu = ({lang, username, profileEvent, settingEvent, logoutEvent}) => {

    const [option, setOption] = useState("0");

    const userMenuEvent = (event) => {
        switch (event.target.value) {
            case "1":
                profileEvent();
                break;
            case "2":
                settingEvent();
                break;
            case "3":
                logoutEvent();
                break;
            default:
                break;
        }
    }

    return (
        <div>
            {/* Button to trigger the menu, can be a username or an avatar */}
            {/* <Button 
                style={{ display: 'flex', padding: '10px' }}
                onClick={handleClick}      
            >
                <Avatar alt={username} src="user-profile.jpg" style={{ marginRight: '10px' }}>
                    <AccountCircle />
                </Avatar>
                <Typography variant="body1" color='black'
                    style={{ alignSelf: 'center' }}>
                    {username}
                </Typography>
            </Button> */}

            {/* Menu for profile, settings, logout */}
            <Box
                display={"flex"}
                
            >
                    <Select
                        value={option}
                        onChange={userMenuEvent}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        m={0} p={0}
                        disableUnderline={true}
                        variant='standard'
                    >
                        <MenuItem value="0" style={{ display: "none" }}>
                            <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                                <Avatar 
                                    variant="soft"
                                    children={<AccountCircleIcon/>}
                                    sx={{ width: 30, height: 30 }}
                                />
                                <Typography 
                                    variant="body1"
                                    style={{ alignSelf: 'center' }}
                                >
                                    {username}
                                </Typography>
                            </Stack>
                        </MenuItem>
                        <MenuItem value="1">
                            <Box sx={{ flexGrow: 1, display: "flex" }}>
                                <AccountBoxIcon sx={{display: "block", marginRight: 1}}/>
                                <Typography sx={{display: "block"}}>{CONSTANTS.APP_BAR.USER_MENU.PROFILE[lang]}</Typography>
                            </Box>
                        </MenuItem>
                        <MenuItem value="2">
                            <Box sx={{ flexGrow: 1, display: "flex" }}>
                                <SettingsIcon sx={{display: "block", marginRight: 1}}/>
                                <Typography sx={{display: "block"}}>{CONSTANTS.APP_BAR.USER_MENU.SETTING[lang]}</Typography>
                            </Box>
                        </MenuItem>
                        <Divider />
                        <MenuItem value="3" >
                            <Box sx={{ flexGrow: 1, display: "flex" }}>
                                <LogoutIcon sx={{display: "block", marginRight: 1}}/>
                                <Typography sx={{display: "block"}}>{CONSTANTS.APP_BAR.USER_MENU.LOGOUT[lang]}</Typography>
                            </Box>
                        </MenuItem>
                    </Select>
            </Box>
            

        </div>
    );
};

export default UserMenu;
